/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

var log = require('../util/log');

var noop = function noop() {};

/**
 * RxJS subscriptions manager.
 */
var rxSubs = {
  methods: {
    /**
     * @return {void}
     * @protected
     */
    subscribeAll: function subscribeAll() {},

    /**
     * @return {void}
     * @protected
     */
    unsubscribeAll: function unsubscribeAll() {
      this._rxSubs.forEach(function (x) {
        return x.unsubscribe();
      });
      this._rxSubs = [];
    },

    /**
     * @param {Observable<T>} observable
     * @param {function} [next] Next handler or Observer object.
     * @param {function} [error] Error handler.
     * @param {function} [complete] Complete handler.
     * @return {Subscription}
     * @protected
     */
    subscribeTo: function subscribeTo(observable) {
      var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

      var _error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noop;

      var complete = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;

      _error = function error(err) {
        if (process.env.NODE_ENV !== 'production') {
          log.error(err.stack);
        }
        _error(err);
      };

      var subs = observable.subscribe(next, _error, complete);
      this._rxSubs.push(subs);

      return subs;
    }
  },
  beforeCreate: function beforeCreate() {
    /**
     * @type {Subscription[]}
     * @private
     */
    this._rxSubs = [];
  },
  destroyed: function destroyed() {
    this.unsubscribeAll();
  }
};

module.exports = rxSubs;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/mixin/rx-subs.js
// module id = 520
// module chunks = 1